export default __webpack_public_path__ + "static/media/MUST-MATIC.fe097796.png";